import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Proposal } from '@teem/models/proposal';

@Component({
  selector: 'view-proposal',
  templateUrl: './view-proposal.component.html',
  styles: []
})
export class ViewProposalComponent implements OnInit {
  @Input() proposal: Proposal;
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() back: EventEmitter<any> = new EventEmitter();
  activeTab: string = "project-detail";
  terms: any;

  constructor() { }

  ngOnInit(): void {

    if (this.proposal && this.proposal.terms && Array.isArray(this.proposal.terms) && this.proposal.terms.length > 0) {
      this.terms = this.proposal.terms
    }
  }

  getObjectValues(obj: any) {
    return obj ? Object.values(obj) : [];
  }

  deliverableCost(formValues) {
    if (formValues.rate && formValues.quantity) {
      return formValues.rate * formValues.quantity;
    }
    return 0;
  }

  switchTab(tab: string) {
    this.activeTab = tab;
  }

}
